import React, { Fragment } from "react";
import { Header, Divider, Icon, Segment, Button, Grid, Label } from "semantic-ui-react";
import { useStore } from "../../../app/stores/store";
import { observer } from "mobx-react-lite";
import GameListItem from "./GameListItem";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next'; // Assuming you're using react-i18next

export default observer(function GameList() {
  const { t } = useTranslation(); // Hook for translations
  const { gameStore } = useStore();
  const { groupedGames, predicate, setPredicate, applyFilters } = gameStore;

  // Calculate total number of games
  const totalGames = groupedGames.reduce((sum, [_, games]) => sum + games.length, 0);

  // If no games are found, show a message
  if (groupedGames.length === 0) {
    return (
      <Segment placeholder textAlign="center" style={{ marginTop: 25 }}>
        <Grid columns={1} stackable textAlign="center">
          <Grid.Row verticalAlign="middle">
            <Grid.Column>
              <Icon name="search" size="huge" color="grey" />
              <Header as="h2">
                {t('gameList.noGamesFound')}
                <Header.Subheader>
                  {predicate.size > 0 
                    ? t('gameList.tryAdjustingFilters')
                    : t('gameList.noGamesAvailable')}
                </Header.Subheader>
              </Header>
              <div style={{ marginTop: 15 }}>
                <Button as={Link} to="/createGame" primary>
                  <Icon name="plus" /> {t('gameList.createNewGame')}
                </Button>
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    );
  }

  // Regular display when games are found
  return (
    <>
      {/* Games Summary Header */}
      <Segment raised style={{ marginTop: 25, backgroundColor: '#f8f9fa' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
            <Header as="h4" style={{ margin: 0 }}>
              <Icon name="trophy" color="teal" />
              <Header.Content>
                {t('gameList.gamesSummary')}
                <Header.Subheader>
                  {t('gameList.gamesSummarySubheader')}
                </Header.Subheader>
              </Header.Content>
            </Header>
          </div>
        </div>
      </Segment>

      {/* Games By Date */}
      {groupedGames.map(([group, games]) => (
        <Fragment key={group}>
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            margin: '25px 0 15px 0'
          }}>
            <div style={{
              backgroundColor: '#00b5ad', // Teal color to match Semantic UI's teal
              color: 'white',
              padding: '10px 15px',
              borderRadius: '4px',
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
            }}>
              <Icon name="calendar alternate outline" style={{ marginRight: '8px' }} />
              {group}
            </div>
            <div style={{
              marginLeft: '15px',
              color: '#666',
              fontSize: '0.95em'
            }}>
              {games.length} {games.length === 1 ? t('gameList.gameOnDate') : t('gameList.gamesOnDate')}
            </div>
            <Divider style={{ 
              flex: 1, 
              marginLeft: '15px' 
            }} />
          </div>

          {games.map(game => (
            <GameListItem key={game.id} game={game} />
          ))}
        </Fragment>
      ))}
    </>
  );
});